import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import listingReducer from "./slices/listingSlice";
import inspectionReducer from "./slices/inspectionSlice";
import dashboardReducer from "./slices/dbSlice";
import paymentReducer from "./slices/paymentSlice";
import bookingReducer from "./slices/bookingSlice";
import userReducer from "./slices/userSlice";

const store = configureStore({
  reducer: {
    app: authReducer,
    listing: listingReducer,
    inspection: inspectionReducer,
    payment: paymentReducer,
    dashboard: dashboardReducer,
    bookings: bookingReducer,
    users: userReducer,
  },
});

export default store;
